export default __webpack_public_path__ + "3c96fffb43365e94e1ed6a43d7a66032.webp";